import React from 'react';

const TestRedeemed = () => {
  return (
    <div>
      <p>The recipient will then be able to choose their treat and enjoy!</p>
    </div>
  );
};

TestRedeemed.propTypes = {};

export default TestRedeemed;
